import React from 'react'
import type { FC } from 'react'
import { BreadcrumbJsonLd, GatsbySeo, JsonLd } from 'gatsby-plugin-next-seo'
import { useSession } from 'src/sdk/session'

import storeConfig from '../../../store.config'

interface SeoProps {
  data: {
    site:
      | {
          siteMetadata: {
            title: string | null
            description: string | null
            titleTemplate: string | null
          } | null
        }
      | null
      | undefined
  }
  location: { pathname: string; host: string }
}

const Seo: FC<SeoProps> = (props) => {
  const {
    data: { site },
    location: { pathname, host },
  } = props

  const { locale } = useSession()
  const title = site?.siteMetadata?.title ?? ''
  const siteUrl = `https://${host}${pathname}`

  const { storeUrl } = storeConfig
  const canonical = `${storeUrl}${pathname}`

  return (
    <>
      {/* SEO */}
      <GatsbySeo
        title={title}
        description={site?.siteMetadata?.description ?? ''}
        titleTemplate={site?.siteMetadata?.titleTemplate ?? ''}
        language={locale}
        canonical={canonical}
        openGraph={{
          type: 'website',
          url: siteUrl,
          title: title ?? '',
          description: site?.siteMetadata?.description ?? '',
        }}
      />
      <JsonLd
        json={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          url: siteUrl,
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteUrl}s/?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: 'Vivara', item: window.location.origin },
        ]}
      />
      <JsonLd
        json={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'vivara',
          url: window.location.href,
          logo: `${window.location.origin}/icons/HeaderLogo.svg`,
          description: props.data.site?.siteMetadata?.description ?? '',
          sameAs: [
            'https://www.facebook.com/Vivara/?locale=pt_BR',
            'https://www.instagram.com/vivaraonline/?hl=pt-br',
            'https://www.youtube.com/channel/UC5aNmlT5dJXlus6RzIDbmxg',
            'https://www.pinterest.com/vivaraonline/_created/',
            'https://twitter.com/vivaraonline?lang=pt',
          ],
          email: 'sac.ecommerce@vivara.com.br',
        }}
      />
    </>
  )
}

export default Seo
